// Copyright (c) 2026 Riddle, LLC. All rights reserved.
// Author: Ray Harris

const GUID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function resolveTenantId(
  explicitTenantId: string | undefined,
  authority: string | undefined,
): string | undefined {
  if (explicitTenantId !== undefined) {
    return GUID_PATTERN.test(explicitTenantId) ? explicitTenantId.toLowerCase() : undefined;
  }
  if (authority === undefined) {
    return undefined;
  }
  try {
    const segment = new URL(authority).pathname.split("/").find((part) => part.length > 0);
    return segment !== undefined && GUID_PATTERN.test(segment) ? segment.toLowerCase() : undefined;
  } catch {
    return undefined;
  }
}

export function expectedIssuers(tenantId: string, authority: string | undefined): string[] {
  const issuers = [
    `https://${tenantId}.ciamlogin.com/${tenantId}/v2.0`,
    `https://login.microsoftonline.com/${tenantId}/v2.0`,
  ];
  if (authority !== undefined) {
    try {
      issuers.push(`${new URL(authority).origin}/${tenantId}/v2.0`);
    } catch {
    }
  }
  return issuers;
}
